import React from "react";
import { useLanguage } from "../LanguageContext";

const About: React.FC = () => {
    const { t } = useLanguage();
    const a = t.about;
    const titleLines = a.title.split("\n");
    const badgeLines = a.badgeLabel.split("\n");
    const stat1Lines = a.stat1Label.split("\n");
    const stat2Lines = a.stat2Label.split("\n");

    return (
        <section className="about" id="about">
            <div className="section-number on-light">01</div>
            <div className="container">
                <div className="about-grid">
                    <div className="about-text">
                        <span className="section-eyebrow">{a.eyebrow}</span>
                        <h2 className="section-title dark">
                            {titleLines[0]}<br />{titleLines[1]}
                        </h2>
                        <div className="about-rule" />
                        <p>{a.p1}</p>
                        <p>{a.p2}</p>
                        <div className="about-highlight">
                            <div className="highlight-bar" />
                            <p>{a.highlight}</p>
                        </div>
                    </div>

                    <div className="about-visual">
                        <div className="about-badge">
                            <span className="badge-number">
                                20<sup>+</sup>
                            </span>
                            <span className="badge-label">
                                {badgeLines[0]}<br />{badgeLines[1]}
                            </span>
                        </div>
                        <div className="about-stats-mini">
                            <div>
                                <span className="stat-mini-num">{a.stat1Num}</span>
                                <span className="stat-mini-label">{stat1Lines[0]}<br />{stat1Lines[1]}</span>
                            </div>
                            <div>
                                <span className="stat-mini-num">{a.stat2Num}</span>
                                <span className="stat-mini-label">{stat2Lines[0]}<br />{stat2Lines[1]}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
